import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import requestSummaryTable from 'app-ui-componentlibrary/dist/go/components/common/requestSummaryTable';

export const ConnectedRequestSummaryTable = connectDynamic(requestSummaryTable);
export default requestSummaryTable;
